// 文章3数据信息
export default {
  id: '3',
  title: '百日逆糖新生营',
  createTime: '2025-03-22 10:00:00',
  content: `![img](https://cdn.keihong.tech/img/20250422161330505.png)

**适合客户：**为希望逆糖新生的糖友，打造的全方位康复计划

**服务时长：** 持续100天的深度健康重建之旅。

**服务权益：**

- **细胞母乳：**提供90天足量供应，修复细胞，持续调节血糖平衡机制
- **全程血糖监测：**6个连续血糖监测仪，实时掌握血糖变化
- **强化营养方案：**专业轻断食细胞营养疗法，重塑代谢系统
- **专业运动指导：**每月2次线上指导，配智能康复仪和运动工具包
- **深度陪伴：**100天专业督导打卡，季度康复效果复盘，终身随访服务

`
}
